export default __webpack_public_path__ + "static/media/group-img_7725.20a26301.png";